import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appTable]',
    standalone: false
})
export class  TableDirective {

  @HostBinding('class')
  className = 'app-table';
}
